export const itemCategories = [
  {
    label: 'Base Cabinets',
    icon: '/itemCategory/base_cabinet.png',
    hoverIcon: '/itemCategory/base_cabinet_h.png',
    width: 29,
    height: 41
  },
  {
    label: 'Wall Cabinets',
    icon: '/itemCategory/wall_cabinet.png',
    hoverIcon: '/itemCategory/wall_cabinet_h.png',
    width: 53,
    height: 41
  },
  {
    label: 'Oven and Pantry Cabinets',
    icon: '/itemCategory/pantry_cabinet.png',
    hoverIcon: '/itemCategory/pantry_cabinet_h.png',
    width: 27,
    height: 41
  },
  {
    label: 'Bathroom Vanities',
    icon: '/itemCategory/bathroom_vanity.png',
    hoverIcon: '/itemCategory/bathroom_vanity_h.png',
    width: 36,
    height: 41
  },
  {
    label: 'Trim & Details',
    icon: '/itemCategory/trim_detail.png',
    hoverIcon: '/itemCategory/trim_detail_h.png',
    width: 22,
    height: 41
  },
  {
    label: 'Accessories',
    icon: '/itemCategory/accessory.png',
    hoverIcon: '/itemCategory/accessory_h.png',
    width: 22,
    height: 41
  }
]
